import DialogM, { DialogProps } from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'

import FieldsetHeader from '../Fieldset/FieldsetHeader'
import React from 'react'
import { useTheme } from '@mui/material/styles'

type Overwrite<T, U> = Pick<T, Exclude<keyof T, keyof U>> & U

type Props = Overwrite<
  DialogProps,
  {
    title?: string
    children: any
    onClose: Function
    actions?: any
  }
>
const Dialog: React.FC<Props> = ({ title, children, actions, onClose, ...props }) => {
  const theme = useTheme()

  return (
    <DialogM
      onClose={() => onClose()}
      maxWidth={'md'}
      open
      PaperProps={{ sx: { overflow: 'visible' } }}
      {...props}
    >
      <IconButton
        onClick={() => onClose()}
        aria-label="Close"
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          transform: 'translate(40%, -40%)',
          zIndex: 1,
          color: '#fff',
          backgroundColor: theme.palette.primary.main,
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          },
        }}
      >
        <CloseIcon />
      </IconButton>
      {title && <FieldsetHeader title={title} />}
      <DialogContent>{children}</DialogContent>
      <DialogActions style={{ margin: 16 }}>{actions}</DialogActions>
    </DialogM>
  )
}

export default Dialog
